module.exports = __webpack_public_path__ + "img/hero_ourteam.94681748.jpg";